"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let obj = {
    matches: ["newDoc"],
    execute: (commandName, commandOptions) => {
        let qs = "?typeid" + commandOptions.typeId;
        if (commandOptions.parentId)
            qs += "&parentId=" + encodeURIComponent(commandOptions.parentId);
        if (commandOptions.templateInstance)
            for (let prop in commandOptions.templateInstance)
                qs += "&" + prop + "=" + encodeURIComponent(commandOptions.templateInstance[prop]);
        const url = tdBasePath + "/#/newDoc" + qs;
        if (commandOptions.sameTab)
            location.assign(url);
        else {
            let wnd = window.open(url);
            wnd.location.reload();
        }
        return Promise.resolve();
    },
    isBreadcrumbElement: false
};
exports.default = obj;
